import React, { useEffect, useState } from "react";
import { DraggableProvided } from "react-beautiful-dnd";
import { FormGroup } from "react-bootstrap";
import {
  useWorkShop,
  WorkshopSectionContent,
} from "../../../../../../../contexts/workshop-context/WorkshopContext";
import MediaCard from "../MediaCard";
interface IProps {
  resource: WorkshopSectionContent;
  uploading?: boolean;
  provided: DraggableProvided;
}

export interface MediaURLContent {
  text: string;
  url: string;
}

const MediaURL = (props: IProps) => {
  const { updateResourceContent } = useWorkShop();

  const [state, setState] = useState<MediaURLContent>({ text: "", url: "" });

  const { content, orderNo } = props.resource;

  useEffect(() => {
    try {
      const data = JSON.parse(content);
      if (data) {
        setState(data);
      } else {
        setState({ text: data, url: data });
      }
    } catch (e) {
      setState({ text: content, url: content });
    }
  }, [content]);

  const upldateContent = (text: string, url: string) => {
    updateResourceContent(
      orderNo,
      JSON.stringify({
        text: text,
        url: url,
      })
    );
  };

  return (
    <MediaCard
      resource={props.resource}
      uploading={props.uploading}
      provided={props.provided}
    >
      {props.resource.mode === "EDIT" ? (
        <div>
          <FormGroup>
            <label className="form-label">Text</label>
            <input
              type="text"
              className="app-input"
              value={state.text}
              onChange={(e) => {
                setState({ ...state, text: e.target.value });
                upldateContent(e.target.value, state.url);
              }}
            />
          </FormGroup>
          <FormGroup>
            <label className="form-label">Url</label>
            <input
              type="text"
              className="app-input"
              value={state.url}
              onChange={(e) => {
                setState({ ...state, url: e.target.value });
                upldateContent(state.text, e.target.value);
              }}
            />
          </FormGroup>
        </div>
      ) : (
        <div className="text-center resource-preview-wrapper">
          <div className="resource-preview text-justify">
            <a href={state.url}>{state.text}</a>
          </div>
        </div>
      )}
    </MediaCard>
  );
};

export default MediaURL;
